/** @jsx jsx */

import React, {
  Fragment as _,
  memo,
  useMemo,
  useState,
  useContext,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import { colors } from 'styles/variables';
import getTempTextImageData from 'services/getTempTextImageContinueBtnData';
import expandBlock from 'services/apiHelpers/expandBlock';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column, Button, Box } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { connect } from 'react-redux';
import { interactionContext } from './interactionContext';
import Media from 'components/lib/Media';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import IELayout from 'components/Layouts/IELayout';
import AssessmentResults from './AssessmentResults';
import EditableBtn from '../EditableBtn';
import RetryAssessment from './RetryAssessment';
import FeedbackPassed from './FeedbackPassed';
import FeedbackFailed from './FeedbackFailed';
import ContinueButtonBranching from './ContinueButtonBranching';
import setBlockProps from 'services/apiHelpers/setBlockProps';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  AssessmentResults,
  LearnMore: props => {
    // console.log('LearnMore :', props);

    return null;
  },
  Image,
  TwoColumnLayout,
  SingleColumnLayout,
  FeedbackPassed,
  FeedbackFailed,
  ContinueButton: ContinueBtn,
  ContinueButtonBranching,
  Video,
  SVG,
  Media,
  Audio: null,
  EditableButton: () => null,
  PDF: () => null,
  OpenPDF: () => null,
  RetryAssessment,
  Embed: null,
  Transcript: null,
  ...IELayout(interactionContext),
};

const AssessmentResultsDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  const [passed, updatePassedFailed] = useState<boolean | undefined>(undefined);

  // transform lockDown to 1 / 0 if was saved as boolean
  // don't much matter now that the unlock is checking for any truthy value
  // but good for consistency
  const { lockDown } = interactionBlock?.props as any;

  useEffect(() => {
    if (typeof lockDown === 'boolean') {
      setBlockProps(interactionBlock, {
        lockDown: lockDown ? 1 : 0,
      });
    }
  }, []);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={
          {
            ...interactionBlock,
            enableRetryAssessmentBtn: true,
            passed,
            updatePassedFailed,
          } as any
        }
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
});
// shouldUpdate

export default AssessmentResultsDisplay;
